<template>
  <div class="modal fade" tabindex="-1" id="triageModal" aria-labelledby="triageModalLabel" aria-hidden="true"
       data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog modal-xl modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5 text-center">Triagem</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                  @click="hideModalTriage"></button>
        </div>
        <div class="modal-body">
          <div class="accordion" id="accordionTriage" v-if="visibleModalTriage">
            <div class="accordion-item">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne"
                        aria-expanded="true" aria-controls="collapseOne">
                  Instituição:
                </button>
              </h2>
              <div id="collapseOne" class="accordion-collapse collapse" data-bs-parent="#accordionTriage">
                <div class="accordion-body">
                  <div class="mt-2 text-start">
                    <p>Nome: <strong>{{ protocolUpdatePopup.protocol_info.company_info.name }}</strong></p>
                    <p>Sigla: <strong>{{ protocolUpdatePopup.protocol_info.company_info.code }}</strong></p>
                    <p>Cidade: <strong>{{ protocolUpdatePopup.protocol_info.company_info.city }}</strong></p>
                    <p>Hospital de referência: <strong>
                      {{ protocolUpdatePopup.protocol_info.company_info.reference }} </strong></p>
                    <p>Cidade de referência: <strong>
                      {{ protocolUpdatePopup.protocol_info.company_info.city_reference }} </strong></p>
                    <p>Distância: <b>{{ protocolUpdatePopup.protocol_info.company_info.distance_to_reference }}km </b>
                    </p>
                    <p>Observações: <strong v-html="marked().parse(protocolUpdatePopup.protocol_info.company_info.note??'')">
                    </strong>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                  Solicitante e Responsável:
                </button>
              </h2>
              <div id="collapseTwo" class="accordion-collapse collapse" data-bs-parent="#accordionTriage">
                <div class="accordion-body">
                  <div class="mt-2 text-start" v-if="protocolUpdatePopup.nurse_info">
                    <p>Solicitante: <strong>{{ protocolUpdatePopup.nurse_info.name }}</strong></p>
                    <p>Profissão: <strong>{{ protocolUpdatePopup.nurse_info.professional_type }}</strong></p>
                    <p>Registro: <strong>{{ protocolUpdatePopup.nurse_info.professional_code }} -
                      {{ protocolUpdatePopup.nurse_info.state_code }}</strong></p>
                    <hr>
                  </div>
                  <div class="mt-2 text-start">
                    <p>Responsável{{ !protocolUpdatePopup.nurse_info ? " e Solicitante" : "" }}:
                      <strong>{{ protocolUpdatePopup.responsible_info.name }}</strong></p>
                    <p>Profissão: <strong>{{ protocolUpdatePopup.responsible_info.professional_type }}</strong></p>
                    <p>Registro: <strong>{{
                        protocolUpdatePopup.responsible_info.professional_code
                      }}-{{ protocolUpdatePopup.responsible_info.state_code }}</strong></p>
                  </div>
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header">
                <button class="accordion-button" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                  Paciente:
                </button>
              </h2>
              <div id="collapseThree" class="accordion-collapse collapse show" data-bs-parent="#accordionTriage">
                <div class="accordion-body">
                  <div class="mt-2 text-start">
                    <div v-if="!protocolUpdatePopup.protocol_info.patient_info.mother_info">
                      <p>Paciente: <strong>{{
                          formatName(protocolUpdatePopup.protocol_info.patient_info.name)
                        }}</strong>
                      </p>
                      <p>Data de nascimento:
                        <strong>{{ age(protocolUpdatePopup.protocol_info.patient_info.birthdate) }}</strong>
                      </p>
                      <p v-if="protocolUpdatePopup.protocol_info.patient_info.document !== null">
                        {{ protocolUpdatePopup.protocol_info.patient_info.document_type }}:
                        <strong>
                          {{
                            formatDocument(protocolUpdatePopup.protocol_info.patient_info.document_type, protocolUpdatePopup.protocol_info.patient_info.document)
                          }}
                        </strong>
                      </p>
                      <p v-if="protocolUpdatePopup.protocol_info.patient_info.document_type === 'RG' && protocolUpdatePopup.protocol_info.patient_info.document_issuer && protocolUpdatePopup.protocol_info.patient_info.document_issuer.replace(' ', '') !== ''">
                        Orgão Emissor: <strong>{{
                          protocolUpdatePopup.protocol_info.patient_info.document_issuer
                        }}</strong></p>
                    </div>
                    <div class="mt-2 text-start" v-else>
                      <p>Nome da mãe:
                        <strong>{{
                            formatName(protocolUpdatePopup.protocol_info.patient_info.mother_info.name)
                          }}</strong>
                      </p>
                      <p>Data de nascimento da mãe: <strong>{{
                          age(protocolUpdatePopup.protocol_info.patient_info.mother_info.birthdate)
                        }}</strong></p>
                      <p v-if="protocolUpdatePopup.protocol_info.patient_info.mother_info.document">
                        {{ protocolUpdatePopup.protocol_info.patient_info.mother_info.document_type }} da mãe: <strong>{{
                          formatDocument(protocolUpdatePopup.protocol_info.patient_info.mother_info.document_type,
                              protocolUpdatePopup.protocol_info.patient_info.mother_info.document)
                        }}</strong></p>
                      <p v-if="protocolUpdatePopup.protocol_info.patient_info.mother_info.document_type === 'RG' && protocolUpdatePopup.protocol_info.patient_info.mother_info.document_issuer && protocolUpdatePopup.protocol_info.patient_info.mother_info.document_issuer.replace(' ', '') !== ''">
                        Orgão Emissor:
                        <strong>{{
                            protocolUpdatePopup.protocol_info.patient_info.mother_info.document_issuer
                          }}</strong>
                      </p>
                      <hr>
                      <p>Paciente: <strong>{{
                          formatName(protocolUpdatePopup.protocol_info.patient_info.name)
                        }}</strong>
                      </p>
                      <p>Data de nascimento do paciente:
                        <strong>{{ age(protocolUpdatePopup.protocol_info.patient_info.birthdate) }}</strong>
                      </p>
                    </div>
                    <div class="mt-3">
                      <button class="btn btn-success btn-sm" @click="openPatientRecord()">
                        <i class="bi bi-box-arrow-up-right"></i> Ver Prontuário
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="accordion-item" v-if="protocolUpdatePopup.protocol_info.history.length > 0">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                  Histórico de reabertura:
                </button>
              </h2>
              <div id="collapseFour" class="accordion-collapse collapse" data-bs-parent="#accordionTriage">
                <div class="accordion-body">
                  <div class="mt-2">
                    <a class="d-flex mb-1 fw-bold" href="#"
                       v-for="(item, index) in protocolUpdatePopup.protocol_info.history"
                       :key="index"
                       @click="handleItemHistoricClick(item.report_id)">
                      <i class="bi bi-box-arrow-up-right"></i>
                      <p class="ps-2"> {{ formatHistoric(item) }}</p>
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <div class="accordion-item" v-if="protocolUpdatePopup.files.length > 0">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                  Arquivos:
                </button>
              </h2>
              <div id="collapseFive" class="accordion-collapse collapse" data-bs-parent="#accordionTriage">
                <div class="accordion-body">
                  <a class="d-flex mb-1 fw-bold" href="#" v-for="(item, index) in protocolUpdatePopup.files"
                     :key="index"
                     @click="handleItemFileClick(item.id)">

                    <div v-if="item.extension.includes('pdf')">
                      <i class="bi bi-file-earmark"></i>
                    </div>
                    <div
                        v-else-if="item.extension.includes('png') || item.extension.includes('jpg') || item.extension.includes('jpeg')">
                      <i class="bi bi-file-earmark-image"></i>
                    </div>
                    <div v-else-if="item.extension.includes('mp3') || item.extension.includes('ogg')">
                      <i class="bi bi-file-earmark-music"></i>
                    </div>
                    <div v-else-if="item.extension.includes('mp4')">
                      <i class="bi bi-file-earmark-play"></i>
                    </div>
                    <div v-else>
                      <i class="bi bi-box-arrow-up-right"></i>
                    </div>
                    <p class="ps-2 text-start">{{
                        getTypeFile(item.extension)
                      }} - {{ item.file_name }}
                    </p>
                  </a>
                </div>
              </div>
            </div>
            <div class="accordion-item">
              <h2 class="accordion-header">
                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                  Dados assistenciais:
                </button>
              </h2>
              <div id="collapseSix" class="accordion-collapse collapse" data-bs-parent="#accordionTriage">
                <div class="accordion-body">
                  <div v-if="!protocolUpdatePopup.report_id" class="alert alert-secondary mb-0" role="alert">
                    <i class="bi bi-lock-fill me-1"></i>
                    Os dados assistenciais só podem ser visualizados após iniciar o atendimento. Clique em <strong>Atender</strong> para assumir o caso.
                  </div>
                  <div v-else class="mt-3">
                    <div class="bg-danger-subtle rounded border-2 px-2 pt-3 pb-1 mb-2"
                         v-if="protocolUpdatePopup.AVC_protocol === 1">
                      <p>
                        Protocolo de AVC para trombólise:
                        <strong>{{ formatBoolean(protocolUpdatePopup.AVC_protocol) }}</strong>
                      </p>
                      <p v-if="protocolUpdatePopup.neurological_deficit_duration_id">
                        Tempo do início dos sintomas:
                        <strong>{{ protocolUpdatePopup.neurological_deficit_duration_name }}</strong>
                      </p>
                      <p v-if="protocolUpdatePopup.neurological_deficit_name">
                        Déficit neurológico:
                        <strong>{{ protocolUpdatePopup.neurological_deficit_name }}</strong>
                      </p>
                      <p v-if="protocolUpdatePopup.NHISS_value != null">
                        NHISS:
                        <strong>{{ protocolUpdatePopup.NHISS_value }}</strong>
                      </p>
                      <p v-if="protocolUpdatePopup.thrombolysis_contraindications != null">
                        Contraindicações de trombólise:
                        <strong>{{ formatBoolean(protocolUpdatePopup.thrombolysis_contraindications) }}</strong>
                      </p>
                    </div>
                    <p v-if="protocolUpdatePopup.created_at">
                      Aberto em:
                      <strong>{{ protocolUpdatePopup.created_at }}</strong>
                    </p>
                    <p v-if="protocolUpdatePopup.chat_origin">
                      Origem:
                      <strong>{{ protocolUpdatePopup.chat_origin }}</strong>
                    </p>
                    <p>
                      Tipo de caso:
                      <strong>{{ protocolUpdatePopup.case_type }}</strong>
                    </p>
                    <p v-if="protocolUpdatePopup.cid_subcategory">
                      CID:
                      <strong>{{ protocolUpdatePopup.cid_subcategory.description}}</strong>
                    </p>
                    <p v-if="protocolUpdatePopup.reopen_reason !== null">
                      Motivo da reabertura:
                      <strong>{{ protocolUpdatePopup.reopen_reason }}</strong>
                    </p>
                    <p>
                      Local do caso:
                      <strong>{{ protocolUpdatePopup.case_location }}</strong>
                    </p>
                    <p>
                      Prioridade:
                      <strong>{{ protocolUpdatePopup.case_priority }}</strong>
                    </p>
                    <p>
                      Transferência:
                      <strong>{{ formatBoolean(protocolUpdatePopup.transfer) }}</strong>
                    </p>
                    <div class="bg-primary-subtle rounded p-2" v-if="protocolUpdatePopup.note">
                      <p>
                        História clinica:
                        <strong>{{ protocolUpdatePopup.note }}</strong>
                      </p>
                      <div class="btn btn-success" @click="copyInfo(protocolUpdatePopup.note)">
                        <i class="bi bi-copy "></i>
                        <span class="p-1">Copiar</span>
                      </div>
                    </div>
                    <p v-if="protocolUpdatePopup.cardiovascular_disease_id">
                      Doenças Cardiovasculares:
                      <strong>{{ protocolUpdatePopup.cardiovascular_disease_name }}</strong>
                    </p>
                    <p v-if="protocolUpdatePopup.heartache != null">
                      Dor torácica:
                      <strong>{{ formatBoolean(protocolUpdatePopup.heartache) }}</strong>
                    </p>
                    <p v-if="protocolUpdatePopup.hemodynamic_instability != null">
                      Instabilidade hemodinâmica:
                      <strong>{{ formatBoolean(protocolUpdatePopup.hemodynamic_instability) }}</strong>
                    </p>
                    <p v-if="protocolUpdatePopup.probability_iam_id">
                      Probabilidade de IAM:
                      <strong>{{ protocolUpdatePopup.probability_iam_name }}</strong>
                    </p>
                    <p v-if="protocolUpdatePopup.cardiological_risk_factor_id">
                      Fatores de Risco Cardiológicos:
                      <strong>{{ protocolUpdatePopup.cardiological_risk_factor_name }}</strong>
                    </p>
                    <p v-if="protocolUpdatePopup.patient_drugs">
                      Medicações em uso:
                      <strong>{{ protocolUpdatePopup.patient_drugs }}</strong>
                    </p>
                    <p v-if="protocolUpdatePopup.atheromatosis_id">
                      Ateromatose:
                      <strong>{{ protocolUpdatePopup.atheromatosis_name }}</strong>
                    </p>
                    <p v-if="protocolUpdatePopup.pupillary_reflex">
                      Reflexo Pupilar:
                      <strong>{{ protocolUpdatePopup.pupillary_reflex }}</strong>
                    </p>
                    <p v-if="protocolUpdatePopup.sedation != null">
                      Sedação:
                      <strong>{{ formatBoolean(protocolUpdatePopup.sedation) }}</strong>
                    </p>
                    <div v-if="protocolUpdatePopup.sedation !== 1">

                      <p v-if="protocolUpdatePopup.glasgow != null">
                        Glasgow:
                        <strong>{{ formatGlasgow(protocolUpdatePopup.glasgow) }}</strong>
                      </p>
                      <p v-if="protocolUpdatePopup.motor_loss_location">
                        Perda de força motora localização:
                        <strong>{{ formatMotorLossLocation(protocolUpdatePopup.motor_loss_location) }}</strong>
                      </p>
                      <p v-if="protocolUpdatePopup.motor_loss_side">
                        Perda de força motora lateralidade:
                        <strong>{{ formatMotorLossSide(protocolUpdatePopup.motor_loss_side) }}</strong>
                      </p>
                    </div>
                    <p v-if="protocolUpdatePopup.weight != null">
                      Peso:
                      <strong>{{ protocolUpdatePopup.weight }}</strong>
                    </p>
                    <p v-if="protocolUpdatePopup.patient_agitation">
                      Descrição da agitação:
                      <strong>{{ protocolUpdatePopup.patient_agitation }}</strong>
                    </p>
                    <p v-if="protocolUpdatePopup.patient_suicidal_thoughts != null">
                      Apresenta ideias de suicídio:
                      <strong>{{ formatBoolean(protocolUpdatePopup.patient_suicidal_thoughts) }}</strong>
                    </p>
                    <p v-if="protocolUpdatePopup.patient_drug_intoxication">
                      Sinais de intoxicação por alguma
                      droga:
                      <strong>{{ protocolUpdatePopup.patient_drug_intoxication }}</strong>
                    </p>
                    <p v-if="protocolUpdatePopup.patient_comorbidities">
                      Outras Comorbidades:
                      <strong>{{ protocolUpdatePopup.patient_comorbidities }}</strong>
                    </p>
                    <p v-if="protocolUpdatePopup.psychiatric_treatment != null">
                      Faz tratamento psiquiátrico:
                      <strong>{{ formatBoolean(protocolUpdatePopup.psychiatric_treatment) }}</strong>
                    </p>
                    <p v-if="protocolUpdatePopup.sepsis">
                      Sepse / infecção nosocomial:
                      <strong>{{ protocolUpdatePopup.sepsis }}</strong>
                    </p>
                    <p v-if="protocolUpdatePopup.antimicrobial != null">
                      Uso de antimicrobianos nos últimos 3 meses:
                      <strong>{{ formatBoolean(protocolUpdatePopup.antimicrobial) }}</strong>
                    </p>
                    <p v-if="protocolUpdatePopup.invasive_devices">
                      Descrição dos Dispositivos Invasivos:
                      <strong>{{ protocolUpdatePopup.invasive_devices }}</strong>
                    </p>
                    <p v-if="protocolUpdatePopup.renal_dysfunction">
                      Causa da Disfunção Renal:
                      <strong>{{ protocolUpdatePopup.renal_dysfunction }}</strong>
                    </p>
                    <p v-if="protocolUpdatePopup.CKMB_quantitative">
                      CKMB Quantitativo:
                      <strong>{{ protocolUpdatePopup.CKMB_quantitative }}</strong>
                    </p>
                    <p v-if="protocolUpdatePopup.tropo_quantitative">
                      Tropo Quantitativo:
                      <strong>{{ protocolUpdatePopup.tropo_quantitative }}</strong>
                    </p>
                    <p v-if="protocolUpdatePopup.tropo_unit">
                      Tropo Unidade:
                      <strong>{{ protocolUpdatePopup.tropo_unit }}</strong>
                    </p>
                    <p v-if="protocolUpdatePopup.CPK_quantitative">
                      CPK Quantitativo:
                      <strong>{{ protocolUpdatePopup.CPK_quantitative }}</strong>
                    </p>
                    <p v-if="protocolUpdatePopup.blood_pressure">
                      Pressão Sanguínea:
                      <strong>{{ protocolUpdatePopup.blood_pressure }}</strong>
                    </p>
                    <p v-if="protocolUpdatePopup.apgar_qualitative">
                      APGAR Qualitativo:
                      <strong>{{ protocolUpdatePopup.apgar_qualitative }}</strong>
                    </p>
                    <p v-if="protocolUpdatePopup.apgar_quantitative != null">
                      APGAR Quantitativo:
                      <strong>{{ protocolUpdatePopup.apgar_quantitative }}</strong>
                    </p>
                    <p v-if="protocolUpdatePopup.diagnostic_hypothesis">
                      Hipótese diagnóstica:
                      <strong>{{ protocolUpdatePopup.diagnostic_hypothesis }}</strong>
                    </p>
                    <p v-if="protocolUpdatePopup.diagnostic_hypothesis_another">
                      Outra Hipótese diagnóstica:
                      <strong>{{ protocolUpdatePopup.diagnostic_hypothesis_another }}</strong>
                    </p>
                    <p v-if="protocolUpdatePopup.imaging_exam">
                      Exame de imagem:
                      <strong>{{ protocolUpdatePopup.imaging_exam }}</strong>
                    </p>
                    <p v-if="protocolUpdatePopup.patient_fever != null">
                      Febre:
                      <strong>{{ formatBoolean(protocolUpdatePopup.patient_fever) }}</strong>
                    </p>
                    <p v-if="protocolUpdatePopup.patient_balance">
                      Balanço Hídrico:
                      <strong>{{ protocolUpdatePopup.patient_balance }}</strong>
                    </p>
                    <p v-if="protocolUpdatePopup.patient_glycemia != null && protocolUpdatePopup.patient_glycemia !== ''">
                      Glicemia Capilar:
                      <strong>{{ formatGlycemia(protocolUpdatePopup.patient_glycemia) }}</strong>
                    </p>
                    <p v-if="protocolUpdatePopup.patient_ventilation != null">
                      Ventilação Mecânica:
                      <strong>{{ formatBoolean(protocolUpdatePopup.patient_ventilation) }}</strong>
                    </p>
                    <p v-if="protocolUpdatePopup.patient_ventilation_type">
                      Tipo de ventilação:
                      <strong>{{ protocolUpdatePopup.patient_ventilation_type }}</strong>
                    </p>
                    <p v-if="protocolUpdatePopup.patient_breath === 'AR'">
                      Respiração:
                      <strong>Ar ambiente</strong>
                    </p>
                    <p v-if="protocolUpdatePopup.patient_breath === 'SUPORTE'">
                      Respiração:
                      <strong>Suporte O2</strong>
                    </p>
                    <p v-if="protocolUpdatePopup.patient_breath === 'SUPORTE'">
                      Tipo de suporte O2:
                      <strong>{{ protocolUpdatePopup.patient_air_support }}</strong>
                    </p>
                    <p v-if="protocolUpdatePopup.patient_pam != null">
                      Pressão Arterial Média:
                      <strong>{{ protocolUpdatePopup.patient_pam }}</strong>
                    </p>
                    <p v-if="protocolUpdatePopup.patient_fc != null">
                      Frequência cardíaca:
                      <strong>{{ protocolUpdatePopup.patient_fc }}</strong>
                    </p>
                    <p v-if="protocolUpdatePopup.patient_vasoactive != null">
                      Droga Vasoativa:
                      <strong>{{ formatBoolean(protocolUpdatePopup.patient_vasoactive) }}</strong>
                    </p>
                    <p v-if="protocolUpdatePopup.patient_vasoactive_type">
                      Qual droga vasoativa:
                      <strong>{{ protocolUpdatePopup.patient_vasoactive_type }}</strong>
                    </p>
                    <p v-if="protocolUpdatePopup.patient_nutrition">
                      Via de alimentação:
                      <strong>{{ protocolUpdatePopup.patient_nutrition }}</strong>
                    </p>
                    <p v-if="protocolUpdatePopup.patient_prescription">
                      Prescrição do paciente:
                      <strong>{{ protocolUpdatePopup.patient_prescription }}</strong>
                    </p>
                    <p v-if="protocolUpdatePopup.rate_quantitative != null">
                      Avaliação do solicitante:
                      <strong>{{ protocolUpdatePopup.rate_quantitative }}/10</strong>
                      <span v-if="protocolUpdatePopup.rate_qualitative"> - {{ protocolUpdatePopup.rate_qualitative }}</span>
                    </p>
                    <div v-if="protocolUpdatePopup.protocol_update_traces && protocolUpdatePopup.protocol_update_traces.length > 0">
                      <p class="mb-1">Devoluções à fila:</p>
                      <p class="ps-3 mb-1" v-for="(trace, index) in protocolUpdatePopup.protocol_update_traces" :key="index">
                        <strong>{{ trace.created_at }}</strong> - {{ trace.specialist_name }}: {{ trace.description }}
                        <span v-if="trace.reason"> ({{ trace.reason }})</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="hideModalTriage">Fechar
            janela
          </button>
          <button v-if="!protocolUpdatePopup.report_id" type="button" class="btn btn-primary" :disabled="!enableButton"
                  @click="openAttendanceForm(protocolUpdatePopup)" data-bs-dismiss="modal">Atender
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {marked} from "marked";

export default {
  props: {
    visibleModalTriage: Boolean,
    protocolUpdatePopup: null,
    enableButton: Boolean
  },
  computed: {
    ...mapGetters({
      UrlFile: "StateUrlFile"
    }),
  },
  mounted() {
  },
  beforeUnmount() {
  },
  data() {
    return {};
  },
  methods: {
    marked() {
      return marked
    },
    ...mapActions(["SetProtocol", "GenerateFile"]),
    getTypeFile(extension) {
      if (extension.includes('pdf')) {
        return 'Documento';
      } else if (extension.includes('png') || extension.includes('jpg') || extension.includes('jpeg')) {
        return 'Imagem';
      } else if (extension.includes('mp3')) {
        return 'Áudio';
      } else if (extension.includes('mp4')) {
        return 'Vídeo';
      } else {
        return '';
      }
    },
    formatGlycemia(value) {
      // Códigos do bot antigo; o bot atual grava o valor digitado (ex.: "90").
      if (value === "ACIMA") {
        return "Acima de 180 mg/dl";
      }
      if (value === "ABAIXO") {
        return "Abaixo de 60 mg/dl";
      }
      return value;
    },
    formatBoolean(value) {
      // Colunas booleanas chegam como 1/0; algumas (ex.: antimicrobial) são string "1"/"0".
      if (value === 1 || value === "1" || value === true) {
        return "Sim";
      }
      return "Não";
    },
    formatGlasgow(value) {
      if (value != null) {
        if (value === 0) {
          return "Não Realizado"
        }
        return value;
      }
    },
    openPatientRecord() {
      localStorage.setItem('patient_info', JSON.stringify(this.protocolUpdatePopup.protocol_info.patient_info));
      window.open('/medical-record-detail', '_blank');
    },
    async handleItemHistoricClick(id) {
      localStorage.setItem('reportId', JSON.stringify(id));
      window.open('/historicalreview', '_blank');
    },
    async handleItemFileClick(id) {
      try {
        await this.GenerateFile(id)
        const fileUrl = this.UrlFile;
        const link = document.createElement('a');
        link.href = fileUrl;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch {
        this.$toast.error('Ocorreu um erro, tente novamente.', {
          timeout: 3000,
          closeOnClick: true
        });
      }
    },
    formatHistoric(item) {
      return item.created_at + ' - ' + item.specialist_name
    },
    formatMotorLossSide(value) {
      switch (value) {
        case 'B':
          return 'Bilateral';
        case 'L':
          return 'Esquerda';
        case 'R':
          return 'Direita';
        case 'N':
          return 'Não';
        default:
          return null;
      }
    },
    formatMotorLossLocation(value) {
      switch (value) {
        case 'B':
          return 'Ambos';
        case 'U':
          return 'Superiores';
        case 'D':
          return 'Inferiores';
        case 'N':
          return 'Não';
        default:
          return null;
      }
    },
    formatDocument(tipo, document) {
      if (document !== null) {
        if (tipo === "CPF") {
          document = document.replace(/\D/g, '');
          return document.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
        } else {
          document = document.replace(/\D/g, '');
          return document.replace(/(\d{2})(\d{3})(\d{3})(\d{1})/, '$1.$2.$3-$4');
        }
      }
    },
    formatName(name) {
      if (name !== null) {
        let words = name.toLowerCase().split(" ");
        for (let i = 0; i < words.length; i++) {
          let word = words[i];
          words[i] = word.charAt(0).toUpperCase() + word.slice(1);
        }
        return words.join(" ");
      }
    },
    age(dataNascimento) {
      if (dataNascimento !== null) {
        var partes = dataNascimento.split(' ');
        var dataPartes = partes[0].split('/');
        var horaPartes = partes.length > 1 ? partes[1].split(':') : [0, 0];
        var dataNasc = new Date(dataPartes[2], dataPartes[1] - 1, dataPartes[0], horaPartes[0], horaPartes[1]);

        var hoje = new Date();
        var idade = hoje.getFullYear() - dataNasc.getFullYear();
        var mes = hoje.getMonth() - dataNasc.getMonth();
        var dia = hoje.getDate() - dataNasc.getDate();

        if (mes < 0 || (mes === 0 && dia < 0)) {
          idade--;
        }

        partes = dataNascimento.split(' ');
        var dataFormatada = partes[0]

        if (idade < 1) {
          var meses = (hoje.getMonth() - dataNasc.getMonth()) + (12 * (hoje.getFullYear() - dataNasc.getFullYear()));
          return dataFormatada + " (" + meses + " Meses)";
        } else {
          return dataFormatada + " (" + idade + " Anos)";
        }
      }
    },
    hideModalTriage() {
      this.$emit("hideModalTriage")
    },
    async openAttendanceForm(protocolUpdatePopup) {
      try {
        this.isButtonAtenderDisabled = true;
        await this.SetProtocol(protocolUpdatePopup);
        this.$router.push({name: 'Report'});
      } catch (erro) {
        if (erro.message === '422') {
          this.$toast.warning('Relatório ja criado.', {
            timeout: 3000,
            closeOnClick: true
          });
        } else {
          this.$toast.error('Ocorreu um erro, tente novamente.', {
            timeout: 3000,
            closeOnClick: true
          });
        }
      }
    },
    copyInfo(info) {
      navigator.clipboard.writeText(info);
      this.$toast.success('Texto copiado.', {
        timeout: 3000,
        closeOnClick: true
      });
    }
  },
};

</script>

<style>

div ul li {
  list-style: none;
}
</style>
